// WARNING: Automatically generated code. Any changes to this file will be overwritten.
import { arrayToPickyDict, Dict } from '@nk/utils-lib';
import { DimContainer, DimFlagContainer } from '../types/app-dim-types';
import { EncumbranceTypeEntity } from './app-base-property';
import { PropertyRightTypeEntity } from './app-base-property';
import { PropertyTypeEntity } from './app-base-property';


// property.encumbrance_type.encumbrance_type_key
export enum EncumbranceTypeKey {
  agreement = 'agreement',
  appeal = 'appeal',
  easement = 'easement',
  encumbrance_in_right = 'encumbrance_in_right',
  enforcement_proceeding = 'enforcement_proceeding',
  enforcement_proceeding_in_right = 'enforcement_proceeding_in_right',
  lease_agreement = 'lease_agreement',
  lien = 'lien',
  monetary_easement = 'monetary_easement',
  other_easement = 'other_easement',
  other_right = 'other_right',
  registered_forced_lien = 'registered_forced_lien',
  registered_lien = 'registered_lien',
  sublease_agreement = 'sublease_agreement',
  terms_leasehold_contract = 'terms_leasehold_contract',
}

// property.encumbrance_type.encumbrance_type_key
export class EncumbranceTypeDims implements DimContainer<EncumbranceTypeKey>, DimFlagContainer {
  public flags:
    | {
        agreement: boolean;
        appeal: boolean;
        easement: boolean;
        encumbrance_in_right: boolean;
        enforcement_proceeding: boolean;
        enforcement_proceeding_in_right: boolean;
        lease_agreement: boolean;
        lien: boolean;
        monetary_easement: boolean;
        other_easement: boolean;
        other_right: boolean;
        registered_forced_lien: boolean;
        registered_lien: boolean;
        sublease_agreement: boolean;
        terms_leasehold_contract: boolean;
      }
    | Dict<boolean>;
  public dims: EncumbranceTypeEntity[];
  public keys: EncumbranceTypeKey[];

  constructor(dims: EncumbranceTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.encumbrance_type_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.encumbrance_type_key as EncumbranceTypeKey);
  }
}

// property.property_right_type.property_right_type_key
export enum PropertyRightTypeKey {
  borett = 'borett',
  eiendomsrett = 'eiendomsrett',
  festerett = 'festerett',
  framfesterett = 'framfesterett',
  framfesterett_2 = 'framfesterett_2',
  framfesterett_3 = 'framfesterett_3',
}

// property.property_right_type.property_right_type_key
export class PropertyRightTypeDims implements DimContainer<PropertyRightTypeKey>, DimFlagContainer {
  public flags:
    | {
        borett: boolean;
        eiendomsrett: boolean;
        festerett: boolean;
        framfesterett: boolean;
        framfesterett_2: boolean;
        framfesterett_3: boolean;
      }
    | Dict<boolean>;
  public dims: PropertyRightTypeEntity[];
  public keys: PropertyRightTypeKey[];

  constructor(dims: PropertyRightTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.property_right_type_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.property_right_type_key as PropertyRightTypeKey);
  }
}

// property.property_type.property_type_key
export enum PropertyTypeKey {
  facility_property = 'facility_property',
  housing_cooperative_member_property = 'housing_cooperative_member_property',
  land_co_ownership = 'land_co_ownership',
  leasehold_land = 'leasehold_land',
  other_property_type = 'other_property_type',
  property = 'property',
  section = 'section',
}

// property.property_type.property_type_key
export class PropertyTypeDims implements DimContainer<PropertyTypeKey>, DimFlagContainer {
  public flags:
    | {
        facility_property: boolean;
        housing_cooperative_member_property: boolean;
        land_co_ownership: boolean;
        leasehold_land: boolean;
        other_property_type: boolean;
        property: boolean;
        section: boolean;
      }
    | Dict<boolean>;
  public dims: PropertyTypeEntity[];
  public keys: PropertyTypeKey[];

  constructor(dims: PropertyTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.property_type_key,
      (d) => true
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.property_type_key as PropertyTypeKey);
  }
}
